import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';

export const CircleProgress = (props) => {
  const [offset, setOffset] = useState(0);
  const circleRef = useRef(null);

  const {
    size,
    progress,
    strokeWidth,
    bgCircleColor,
    progressCircleColor,
    children
  } = props;

  const center = useMemo(() => size / 2, [size]);
  const radius = useMemo(() => size / 2 - strokeWidth / 2, [size, strokeWidth]);
  const circumference = useMemo(() => 2 * Math.PI * radius, [radius]);

  useEffect(() => {
    const progressOffset = ((100 - progress) / 100) * circumference;
    setOffset(progressOffset);

    // Force run animation after progress updates from the parent component
    circleRef.current.style =
      'transition: stroke-dashoffset 850ms ease-in-out;';
  }, [circumference, progress]);

  return (
    <div className="circle-progress">
      <svg className="circle-progress__svg" width={size} height={size}>
        <circle
          className="circle-progress__svg__bg"
          stroke={bgCircleColor}
          cx={center}
          cy={center}
          r={radius}
          strokeWidth={strokeWidth}
        />

        <circle
          className="circle-progress__svg__progress"
          stroke={progressCircleColor}
          cx={center}
          cy={center}
          r={radius}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          ref={circleRef}
          transform={`rotate(-90 ${center} ${center})`}
        />
      </svg>

      <div className="circle-progress__text">{children || `${progress}%`}</div>
    </div>
  );
};

CircleProgress.defaultProps = {
  size: 120,
  strokeWidth: 15,
  bgCircleColor: '#b1b1b1',
  progressCircleColor: '#ffeb01',
  children: ''
};

CircleProgress.propTypes = {
  size: PropTypes.number,
  progress: PropTypes.number.isRequired,
  strokeWidth: PropTypes.number,
  bgCircleColor: PropTypes.string,
  progressCircleColor: PropTypes.string,
  children: PropTypes.node
};
